
import React from 'react';
import { Palette } from 'lucide-react';
import { FormControl, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ColorScheme as ColorSchemeType } from '@/types/trader';

interface ColorSchemeOption {
  value: ColorSchemeType | string;
  label: string;
}

interface ColorSchemeSelectorProps {
  colorSchemes: ColorSchemeOption[];
  value: string;
  onChange: (value: string) => void;
}

export const ColorSchemeSelector = ({ 
  colorSchemes, 
  value, 
  onChange 
}: ColorSchemeSelectorProps) => {
  return (
    <FormItem>
      <FormLabel className="flex items-center gap-1">
        <Palette className="h-4 w-4" />
        Color Scheme
      </FormLabel>
      <Select onValueChange={onChange} defaultValue={value}>
        <FormControl>
          <SelectTrigger>
            <SelectValue placeholder="Select a color scheme" />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          {colorSchemes.map((scheme) => (
            <SelectItem key={scheme.value.toString()} value={scheme.value.toString()}>
              {scheme.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <FormMessage />
    </FormItem>
  );
};
